import React, {useEffect, useState, useRef, useContext} from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslate } from 'react-polyglot';

import { ExplorerContext } from "../../ExplorerContext";

import fetchHelperService from "../../../../../services/fetchHelper";

import { Card } from "@material-ui/core";

import { Bar } from 'react-chartjs-2';
import moment from 'moment';

function CardTypeExaminationageDistribution(props) {
    let history = useHistory();
    const t = useTranslate();

    let explorer = useContext(ExplorerContext);

    let chartRef = useRef();

    const [data, setData] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState([]);

    function fetchData() {
        if (props.onChangeStart != undefined) props.onChangeStart();
        fetchHelperService.fetchRetry("/dataapi/api/dogs/filter/carddata/examinationagedistribution", 2000, 3, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({
                filters: explorer.filters != undefined ? explorer.filters.filter(i => i.type != "regnumber") : [],
                type: props.examtype
            }),
        }).then(response => {
            if (response.ok && response.status === 200) return response.json();
        }).then(json => {
            setData(json.data);
            setAppliedFilters(JSON.parse(JSON.stringify(explorer.filters)));
            if (props.onChange != undefined) props.onChange();
        }).catch(error => console.error("Error:", error));
    }

    useEffect(() => {
        if (
            JSON.stringify(explorer.filters) != JSON.stringify(appliedFilters)
        ) {
            fetchData();
        }
    }, [explorer.filters, props.examtype]);

    return (
        <Card className="dogexplorer-card-examinationagedistribution">
            <h1>{t("dogexplorer.statistics.cards.examinationagedistribution.description")}</h1>
            <Bar
                ref={chartRef}
                chartId="barchart1-1"
                options={{
                    onClick: (evt, data) => {
                        let examAge = chartRef.current.chartInstance.getElementsAtXAxis(evt)[0]._index;
                        let tempFilter = explorer.filters.filter(i => i.type != "helse" + ".examinationage");
                        tempFilter.push({
                            type: "helse" + ".examinationage",
                            stage: "post",
                            operation: "eq",
                            value: examAge
                        });
                        explorer.updateFilters(tempFilter);
                    },
                    tooltips: {
                        intersect: false
                    },
                    scales: {
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: t("dogexplorer.statistics.cards.examinationagedistribution.currentage")
                                }
                            }
                        ],
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: t("dogexplorer.statistics.cards.examinationagedistribution.numberofsurveys")
                                }
                            }
                        ]
                    }
                }}
                data={{
                    labels: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],
                    datasets: [
                        {
                            backgroundColor: "#382e92",
                            label: t("dogexplorer.statistics.cards.examinationagedistribution.number"),
                            data: data
                        }
                    ]
                }}
                maxWidth={50}
                maxHeight={50}
                //redraw={true}
            ></Bar>
        </Card>
    );
}

export default CardTypeExaminationageDistribution;